import { render, staticRenderFns } from "./CostsFilter.vue?vue&type=template&id=48561f88&scoped=true&"
import script from "./CostsFilter.vue?vue&type=script&lang=js&"
export * from "./CostsFilter.vue?vue&type=script&lang=js&"
import style0 from "./CostsFilter.vue?vue&type=style&index=0&id=48561f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48561f88",
  null
  
)

export default component.exports